/// <amd-module name="Release/Landing/HubContent/Deployments/Actions" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { Deployment, DefinitionEnvironmentReference, DeploymentStatus, DeploymentOperationStatus, Release, ReleaseEnvironment } from "Release/Client/Contracts/Release";
import { IDeploymentsFilterState } from "Release/Landing/HubContent/Filter/FilterTypes";

export interface IDeploymentsPayload {
    deployments: Deployment[];
    definitionId: number;
    continuationToken: number;
    filterState?: IDeploymentsFilterState;
    environments?: DefinitionEnvironmentReference[]
}

export interface IUpdateDeploymentStatus {
    definitionId: number;
    environmentId: number;
    deploymentsStatus: DeploymentStatus;
    operationStatus: DeploymentOperationStatus;
}

export interface IUpdateDeploymentsForCreatedReleasePayload {
    definitionId: number;
    release: Release;
}

export interface IDeploymentStartedPayload {
    definitionId: number;
    release: Release;
    releaseEnvironmentId: number;
}

export class DeploymentsActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-deployments-actions";
    }

    public initialize(instanceId?: string) {
    }

    public get setDeployments(): Action<IDeploymentsPayload> {
        return this._setDeployments;
    }

    public get deploymentsUpdatedWithMore(): Action<IDeploymentsPayload> {
        return this._deploymentsUpdatedWithMore;
    }

    public get updateDeploymentStatus(): Action<IUpdateDeploymentStatus> {
        return this._updateDeploymentStatus;
    }

    public get updateDeploymentsForCreatedRelease(): Action<IUpdateDeploymentsForCreatedReleasePayload> {
        return this._updateDeploymentsForCreatedRelease;
    }

    public get handleDeploymentStarted(): Action<IDeploymentStartedPayload> {
        return this._handleDeploymentStarted;
    }

    private _setDeployments = new Action<IDeploymentsPayload>();
    private _deploymentsUpdatedWithMore = new Action<IDeploymentsPayload>();
    private _updateDeploymentStatus = new Action<IUpdateDeploymentStatus>();
    private _updateDeploymentsForCreatedRelease = new Action<IUpdateDeploymentsForCreatedReleasePayload>();
    private _handleDeploymentStarted = new Action<IDeploymentStartedPayload>();
}
